<template>
  <div id="app">
      <HeaderTop>
      </HeaderTop>
    <router-view/>
  </div>
</template>
<script type="text/javascript">
    import HeaderTop from '@/components/HeaderTop.vue'
    export default {
      name: 'index',
      components: {
        HeaderTop
      }
    }
</script>
<style lang="scss">
#app {
  font-family: '微软雅黑','serif','Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #4C4C4E;
  min-width: 1200px;
}
</style>
